"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MUITheme = void 0;
var _styles = require("@mui/material/styles");
const primitiveTokens = {
  palette: {
    main: {
      black: "#212121",
      white: "#fafafa",
      accentGrey: "#f1f1f1",
      accentDarkGrey: "#e2e2e2",
      accent: "#4086ff",
      accentGreen: "#00c48c",
      redDecline: "#d0021b",
      accentSunglow: "#ffc200"
    },
    text: {
      colorTextSecondary1: "#666666",
      colorTextSecondary2: "#9b9b9b",
      colorTextSecondary3: "#ffffff"
    }
  },
  fontFamily: '"Mulish", sans-serif'
};
const MUITheme = exports.MUITheme = (0, _styles.createTheme)({
  cssVariables: true,
  breakpoints: {
    keys: ["xs", "sm", "md", "lg", "xl"],
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920
    }
  },
  palette: {
    text: {
      primary: primitiveTokens.palette.text.colorTextSecondary1,
      secondary: "#fff",
      disabled: "#D6D6D6",
      statusRed: "#EF5265",
      red: primitiveTokens.palette.main.redDecline,
      orange: "#F18D5A",
      darkGrey: primitiveTokens.palette.main.black,
      lightGrey: primitiveTokens.palette.text.colorTextSecondary2,
      footerText: "#FFFFE1",
      white: "#fff",
      black: "#000",
      lilac: "#6F5ED7",
      hover: {
        blue: "#005ACB",
        red: primitiveTokens.palette.main.redDecline,
        black: "#333"
      }
    },
    primary: {
      main: primitiveTokens.palette.main.accent,
      dark: "#005ACB"
    },
    secondary: {
      main: "#E67381",
      dark: primitiveTokens.palette.main.redDecline
    },
    purple: {
      main: "#220D3A",
      light: "#412f55"
    },
    background: {
      disabled: {
        gray: "#D6D6D6"
      },
      hover: {
        blue: "#ecf3fe",
        red: primitiveTokens.palette.main.redDecline,
        black: "#333"
      },
      grey: "#D6D6D6",
      lightGrey: "#F8F8F8",
      mainContent: primitiveTokens.palette.main.white,
      footer: "#211D24",
      white: "#fff",
      black: "#333",
      red: primitiveTokens.palette.main.redDecline,
      succesBox: "#E7FFF8",
      alertBox: "#FDE5E8",
      warningBox: "#FDF3E5",
      infoBox: "#DEEAFF"
    },
    border: {
      primary: "#f5f7f8",
      secondary: "#ccc",
      mainContent: primitiveTokens.palette.main.white,
      alertBox: "#E67381",
      warningBox: "#F18D5A",
      grey: "#D6D6D6",
      inputBorder: "rgba(25,25,25,.32)"
    },
    success: {
      main: primitiveTokens.palette.main.accentGreen
    },
    error: {
      main: "#B00020"
    },
    infoBoxLink: "#067AD7",
    warning: {
      main: "#F18D5A"
    },
    boxShadow: `0 1px 1px 0 rgba(0, 0, 0, 0.07),
        0 2px 1px - 1px rgba(0, 0, 0, 0.07),
        0 1px 3px 0 rgba(0, 0, 0, 0.1)`
  },
  typography: {
    fontFamily: primitiveTokens.fontFamily,
    fontWeight: 500,
    h2: {
      color: primitiveTokens.palette.main.black,
      fontSize: 36,
      fontWeight: 600,
      lineHeight: "45px"
    },
    h3: {
      color: primitiveTokens.palette.main.black,
      fontSize: 32,
      fontWeight: 600,
      letterSpacing: -0.5,
      lineHeight: "32px"
    },
    h4: {
      color: primitiveTokens.palette.main.black,
      fontSize: 24,
      fontWeight: 600,
      lineHeight: "30px"
    },
    h5: {
      color: primitiveTokens.palette.main.black,
      fontSize: 22,
      fontWeight: 600,
      lineHeight: "32px"
    },
    h6: {
      color: primitiveTokens.palette.main.black,
      fontSize: 20,
      fontWeight: 600,
      lineHeight: "25px"
    },
    body1: {
      color: primitiveTokens.palette.main.black,
      fontWeight: 400,
      fontSize: "1rem"
    },
    body2: {
      color: "#616161",
      fontSize: 18,
      lineHeight: "28px"
    },
    subtitle1: {
      color: primitiveTokens.palette.main.black,
      fontSize: 18,
      fontWeight: "bold"
    },
    subtitle2: {
      color: primitiveTokens.palette.text.colorTextSecondary1,
      fontSize: 14,
      lineHeight: "21px"
    },
    button: {
      fontFamily: primitiveTokens.fontFamily
    }
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: themeParam => ({
        ":root": {
          "--app-transition-duration-standard": `${themeParam.transitions.duration.standard}ms`,
          "--app-transition-easing-standard": themeParam.transitions.easing.easeInOut,
          "--app-transition-standard": [`${themeParam.transitions.duration.standard}ms`, themeParam.transitions.easing.easeInOut].join(" ")
        },
        body: {
          margin: 0,
          "-webkit-font-smoothing": "antialiased",
          "-moz-osx-font-smoothing": "grayscale"
        },
        "::-webkit-scrollbar": {
          width: "5px",
          height: "5px",
          backgroundColor: "#f2f2f2"
        },
        "::-webkit-scrollbar-thumb": {
          background: "#999",
          borderRadius: "10px"
        }
      })
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          font: "inherit"
        }
      }
    }
  },
  primitiveTokens
});
var _default = exports.default = MUITheme;